/**
 * 앱별 테마 확장 시스템
 * 메인 테마를 기반으로 앱별 커스터마이징 지원
 */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { lightTheme, darkTheme } from './theme';
/**
 * 앱별 테마 생성 유틸리티
 */ export function createAppTheme(baseTheme, appColors) {
    return _object_spread_props(_object_spread({}, baseTheme), {
        primary: appColors.primary,
        primaryDark: appColors.primaryDark,
        primaryLight: appColors.primaryLight,
        secondary: appColors.secondary,
        secondaryDark: appColors.secondaryDark,
        secondaryLight: appColors.secondaryLight
    });
}
/**
 * CSS 변수 생성 유틸리티
 */ export function createCSSVariables(theme, appColors) {
    return {
        '--primary': appColors.primary,
        '--primary-dark': appColors.primaryDark,
        '--primary-light': appColors.primaryLight,
        '--secondary': appColors.secondary,
        '--secondary-dark': appColors.secondaryDark,
        '--secondary-light': appColors.secondaryLight,
        '--background-gradient-from': appColors.backgroundGradientFrom,
        '--background-gradient-to': appColors.backgroundGradientTo,
        '--text': theme.text,
        '--text-secondary': theme.textSecondary,
        '--text-muted': theme.textMuted,
        '--border': theme.border,
        '--paper': theme.paper,
        '--shadow': theme.shadow
    };
}
/**
 * 테마 적용 헬퍼 함수
 */ export function applyThemeVariables(appColors) {
    var isDark = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var baseTheme = isDark ? darkTheme : lightTheme;
    var cssVariables = createCSSVariables(baseTheme, appColors);
    Object.entries(cssVariables).forEach(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        document.documentElement.style.setProperty(key, value);
    });
}
/**
 * 체스 앱 테마 색상
 */ export var chessAppColors = {
    // 라이트 모드: 갈색 톤 (체스 친화적)
    primary: '#8b4513',
    primaryDark: '#5d2f0a',
    primaryLight: '#cd853f',
    secondary: '#daa520',
    secondaryDark: '#b8860b',
    secondaryLight: '#f0e68c',
    backgroundGradientFrom: '#1a1611',
    backgroundGradientTo: '#2d2419'
};
/**
 * 체스 앱 다크 테마 색상
 */ export var chessAppDarkColors = {
    primary: '#daa520',
    primaryDark: '#b8860b',
    primaryLight: '#f0e68c',
    secondary: '#cd853f',
    secondaryDark: '#8b4513',
    secondaryLight: '#deb887',
    backgroundGradientFrom: '#0a0a08',
    backgroundGradientTo: '#1a1611'
};
/**
 * EduSense 앱 테마 색상 (블루 계열)
 */ export var edusenseAppColors = {
    // 라이트 모드: 블루 톤 (학습 친화적)
    primary: '#667eea',
    primaryDark: '#4c63d2',
    primaryLight: '#8b9cf7',
    secondary: '#764ba2',
    secondaryDark: '#5a3a7c',
    secondaryLight: '#9d7bc8',
    backgroundGradientFrom: '#667eea',
    backgroundGradientTo: '#764ba2'
};
/**
 * EduSense 앱 다크 테마 색상
 */ export var edusenseAppDarkColors = {
    primary: '#8b9cf7',
    primaryDark: '#667eea',
    primaryLight: '#a5b4f9',
    secondary: '#9d7bc8',
    secondaryDark: '#764ba2',
    secondaryLight: '#b8a1d6',
    backgroundGradientFrom: '#1e1e2e',
    backgroundGradientTo: '#2a2a3e'
};
